import Link from "@/components/Link";
import { FC } from "react";

const PdfViewerErrorMessage: FC<{ url: string }> = ({ url }) => {
  return (
    <p className="text-swdc-black-600 text-center">
      Your browser version is not supported by PDF.js. Please download the PDF
      to view it:{" "}
      <Link
        className="text-swdc-blue-500 active:text-swdc-blue-600 underline hover:decoration-2 active:decoration-2"
        href={url}
      >
        Download PDF
      </Link>
    </p>
  );
};

export default PdfViewerErrorMessage;
